"use client";
import Script from "next/script";

const AudioEyeScript = () => {
    const audioEyeId = process.env.NEXT_PUBLIC_AUDIOEYE_ID;
    if (!audioEyeId || audioEyeId.toLowerCase() === "false") {
        return null;
    }
    return (
        <>
            <Script
                id="audioeye-sitehash"
                strategy="beforeInteractive"
            >{`window.__AudioEyeSiteHash = "${audioEyeId}"`}</Script>
            <Script
                id="audioeye-loader"
                src="https://wsmcdn.audioeye.com/aem.js"
                strategy="lazyOnload"
            />
        </>
    );
};

export default AudioEyeScript;
